import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../utils/cn';
const Label = React.forwardRef(({ className, required, children, ...props }, ref) => {
    return (_jsxs("label", { ref: ref, className: cn('text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide', className), ...props, children: [children, required && _jsx("span", { className: "text-red-500 ml-0.5", children: "*" })] }));
});
Label.displayName = 'Label';
export { Label };
